// extracted by mini-css-extract-plugin
export var bodytext = "SectionStandardSignPostCards-module--bodytext--f71b1 SectionStandardSignPostCards-module--header--81d0e";
export var buttonwrapper = "SectionStandardSignPostCards-module--buttonwrapper--8e89c";
export var cardsection = "SectionStandardSignPostCards-module--cardsection--6e225";
export var header = "SectionStandardSignPostCards-module--header--81d0e";
export var signpostcards = "SectionStandardSignPostCards-module--signpostcards--6f793";